export default __webpack_public_path__ + "static/media/pictogramRepayments40.8c0a4d41.svg";